import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { trackEvent } from 'shared/src/utils/analytics'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import instagramIcon from '../../assets/follow-us-instagram.svg'
import tikTokIcon from '../../assets/follow-us-tiktok.svg'
import shareIcon from '../../assets/follow-us-share.svg'
import { serifFontFamily } from 'utils/styles'
import { Link } from '../Link'
import { Button } from '../Button'
import { writeToClipboard } from 'components/feed/ShareButton'
import { addNotificationContext } from 'components/notifications'
import { INSTAGRAM_URL, SHOPPER_URL, TIK_TOK_URL } from 'utils/urls'

const useStyles = createUseStyles({
  container: {
    marginLeft: 28,
    marginRight: 28,
  },
  title: {
    fontFamily: serifFontFamily,
    fontWeight: 600,
    fontSize: 22,
    lineHeight: '30.8px',
    color: 'white',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
})

interface Props {
  className?: string
}

export const FollowUs: FC<Props> = flowMax(
  addDisplayName('FollowUs'),
  addTranslationHelpers,
  addNotificationContext,
  addHandlers({
    onShare:
      ({ showNotification, t }) =>
      () => {
        const sendEvent = () => {
          trackEvent(
            {
              category: 'general',
              action: 'share',
            },
            {
              url: SHOPPER_URL,
            }
          )
        }

        writeToClipboard(SHOPPER_URL)
          .then(() => {
            showNotification({ text: t('shareAlert'), style: 'top' })
            sendEvent()
          })
          .catch()
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),

  ({ onShare, classes, className, t }) => (
    <div className={cx(classes.container, className)}>
      <h2 className={classes.title}>{t('menu.followUs.title')}</h2>
      <div>
        <Link url={INSTAGRAM_URL} newTab>
          <img src={instagramIcon} alt={t('menu.followUs.instagramAlt')} />
        </Link>
        <Link url={TIK_TOK_URL} newTab>
          <img src={tikTokIcon} alt={t('menu.followUs.tikTokAlt')} />
        </Link>
        <Button onClick={onShare}>
          <img src={shareIcon} alt={t('menu.followUs.shareAlt')} />
        </Button>
      </div>
    </div>
  )
)
